export const COLORS = {
    text: {
      light: '#111621', // night
      dark: '#F5F0F6', // magnolia
    },
    background: {
      light: '#fffde7', // off-white
      dark: '#111621', // night
    },
    primary: {
      light: 'hsl(340deg, 100%, 40%)', // Pinkish-red
      dark: 'hsl(50deg, 100%, 50%)', // Yellow
    },
    secondary: {
      light: 'hsl(250deg, 100%, 50%)', // Purplish-blue
      dark: 'hsl(190deg, 100%, 40%)', // Cyan
    },
    paper: {
      light: '#F5F0F6',
      dark: '#2A313A',
    },
    // Grays, scaling from least-noticeable to most-noticeable
    gray300: {
      light: 'hsl(0deg, 0%, 70%)',
      dark: 'hsl(0deg, 0%, 30%)',
    },
    gray500: {
      light: 'hsl(0deg, 0%, 50%)',
      dark: 'hsl(0deg, 0%, 50%)',
    },
    gray700: {
      light: 'hsl(0deg, 0%, 30%)',
      dark: 'hsl(0deg, 0%, 70%)',
    },
  };
  
  export const COLOR_MODE_KEY = 'color-mode';
  export const INITIAL_COLOR_MODE_CSS_PROP = '--initial-color-mode';